import { GQLStoreBaseFragment } from '@theprintbar/graphql';
import { getCurrencyValue } from '../../utils';

export function getPartnerPortalPrice(price: number | string, store: GQLStoreBaseFragment) {
	const convertedPrice = typeof price === 'string' ? parseFloat(price) : price;
	let basePrice = (convertedPrice / 100) * (100 - parseInt(store.discount));

	return getCurrencyValue(basePrice);
}
